import { databaseRef } from "../Utilities/firebase";

/* ------------- ACTIONS ------------- */
export const REMOVE_SHOP_ITEM = "REMOVE_SHOP_ITEM";
export const CHECK_ITEM = "CHECK_ITEM";
export const EMPTY_SHOP = "EMPTY_SHOP";
export const REMOVE_ALL_SHOP_ITEMS = "REMOVE_ALL_SHOP_ITEMS";
export const ADD_CUSTOM_TO_SHOP = "ADD_CUSTOM_TO_SHOP";

/* ------------ ACTION CREATORS --------- */
export function addCustomItemToShopping(
  user,
  name,
  comment,
  quantity,
  fetchEAN,
  fullname,
  size,
  unit_id,
  dep_id,
  dep_name,
  cat_id,
  cat_name,
  subcat_id,
  subcat_name,
  image,
  carbon_fp,
  water_fp
) {
  var EANcode = "";

  if (fetchEAN !== "") {
    EANcode = fetchEAN;
  } else {
    EANcode = Math.floor(Math.random() * 10000000) + 1000000000;
  }
  if (image === null) {
    image = "";
  }

  var existingQty = 0;
  databaseRef
    .ref("users/" + user + "/shopping/" + EANcode)
    .child("quantity")
    .once("value", function (snapshot) {
      if (snapshot.val() !== undefined && snapshot.val() !== null) {
        existingQty = snapshot.val();
      }
    });

  var dates = [];
  var date = new Date().toISOString();
  for (var i = 0; i < quantity; i++) {
    dates.push(date);
  }

  var item = {
    EANcode: EANcode,
    name: name,
    fullname: fullname,
    size: size,
    unit_id: unit_id,
    dates: dates,
    comment: comment,
    quantity: parseInt(existingQty + quantity),
    amount: 100,
    dep_id: dep_id,
    dep_name: dep_name,
    cat_id: cat_id,
    cat_name: cat_name,
    subcat_id: subcat_id,
    subcat_name: subcat_name,
    image: image,
    carbon_fp: carbon_fp,
    water_fp: water_fp,
  };

  databaseRef
    .ref("users/" + user + "/shopping")
    .child(EANcode)
    .set(item);

  return { type: ADD_CUSTOM_TO_SHOP };
}

export function removeShoppingItem(user, item, removeAll) {
  let decQuant = 0;
  databaseRef
    .ref("users/" + user + "/shopping/" + item.EANcode)
    .child("quantity")
    .once("value", function (snapshot) {
      let curVal = snapshot.val();
      decQuant = curVal - 1;
    });
  if (removeAll) {
    decQuant = 0;
  }

  if (decQuant === 0) {
    databaseRef
      .ref("users/" + user + "/shopping")
      .child(item.EANcode)
      .remove();
  } else {
    let newItem = { ...item, quantity: decQuant };
    databaseRef
      .ref("users/" + user + "/shopping")
      .child(item.EANcode)
      .set(newItem);
  }

  return { type: REMOVE_SHOP_ITEM };
}

export function checkItem(user, item) {
  let checkMode = false;

  if (item.checked === true) {
    checkMode = false;
  } else if (item.checked === false) {
    checkMode = true;
  } else {
    checkMode = true;
  }

  let checkedItem = {
    ...item,
    checked: checkMode,
  };

  databaseRef
    .ref("users/" + user + "/shopping")
    .child(item.EANcode)
    .set(checkedItem);

  return { type: CHECK_ITEM };
}

export function removeAllShoppingItems(user) {
  databaseRef.ref("users/" + user + "/shopping").remove();

  return { type: REMOVE_ALL_SHOP_ITEMS };
}
